import { render, staticRenderFns } from "./ContactNote.vue?vue&type=template&id=f3b9b890&scoped=true&"
import script from "./ContactNote.vue?vue&type=script&lang=js&"
export * from "./ContactNote.vue?vue&type=script&lang=js&"
import style0 from "./ContactNote.vue?vue&type=style&index=0&id=f3b9b890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b9b890",
  null
  
)

export default component.exports